import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NewPort, Port } from "src/app/domain/models/Port";
import { Routes } from "src/app/infrastructure/routes";
import { PortGateway } from "../gateway/PortGateway";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export class PortService extends PortGateway {

  constructor(private _http: HttpClient) {
    super()
  }

  getAll(): Observable<Port[]> {
    return this._http.get<Port[]>(Routes.portApi + '/GetAll')
  }

  getOriginPorts(): Observable<Port[]> {
    return this._http.get<Port[]>(Routes.portApi + '/GetOriginPorts')
  }

  getDestinationPortsByCountry(countryId: number): Observable<Port[]> {
    return this._http.get<Port[]>(Routes.portApi + '/GetDestinationPortByCountry', {params: {countryId}})
  }

  create(port: NewPort): Observable<Port> {
      return this._http.post<Port>(Routes.portApi + '/Create', port)
  }

  getAllPaged(pageNumber: number = 1, pageSize: number= 10): Observable<PageResult<Port>> {
      return this._http.get<PageResult<Port>>(Routes.portApi + '/GetAllPaginated', {params: {pageNumber, pageSize}})
  }
}
